import type { ReactNode } from "react";
import { IconBlad, IconInformacja, IconKrzyzyk, IconOstrzezenie } from "../icons/index.js";

/**
 * BN-1..BN-3: baner trwajacego STANU. Toast = zdarzenie, baner = stan; baner trwa,
 * dopoki trwa stan, i znika sam, gdy stan ustapi.
 *
 * BN-2: pelna szerokosc kolumny tresci, NAD kartami; tint --status-*-bg, obrys
 * --status-*-border, tekst w --text (kolor niesie ikona i obrys, nie tresc).
 * BN-3: maksymalnie JEDEN baner naraz. Wybiera go widok, ktory wie, co mowi kazdy kandydat (np. SessionPage jawnie
 * stawia niepelna ocene brzmienia przed objasnieniem plakietek), a nie waga wariantu: w widokach oceny ostrzezenia ida
 * wariantem informacji, wiec kandydaci czesto maja ten sam wariant.
 *
 * Wartosci 1:1 z gotowca banner.html.
 */

export type WariantBanera = "danger" | "warning" | "info";

const IKONA: Record<WariantBanera, (p: { size?: number }) => React.JSX.Element> = {
  danger: IconBlad,
  warning: IconOstrzezenie,
  info: IconInformacja,
};

export function Banner({
  wariant,
  tekst,
  akcja,
  onZamknij,
  pilny = false,
}: {
  wariant: WariantBanera;
  tekst: string;
  /** BN-2: opcjonalna akcja po prawej ("Wznów", "Przejdź do ustawień"). */
  akcja?: ReactNode;
  /** BN-1: recznie zamykalny jest TYLKO baner czysto informacyjny. */
  onZamknij?: () => void;
  /**
   * Pilnosc dla czytnika niezalezna od koloru: baner informacji, ktory stoi w miejscu ostrzezenia (nieudana akcja albo
   * odswiezenie, niepelny wynik, podmieniony wybor), ma przerwac czytnikowi jak ostrzezenie. Potrzebne tam, gdzie
   * ostrzezenie nie moze miec bursztynu (widoki oceny, gdzie bursztyn to zloto, czyli "najlepsze"), a komunikat nadal
   * jest pilny. Zmiana koloru nie zmienia pilnosci.
   */
  pilny?: boolean;
}): React.JSX.Element {
  const Ikona = IKONA[wariant];
  return (
    <div
      className="banner"
      data-variant={wariant}
      // Blad i ostrzezenie przerywaja czytnikowi, informacja czeka na przerwe (chyba ze jest pilna).
      role={wariant === "info" && !pilny ? "status" : "alert"}
    >
      <span className="banner__icon" aria-hidden="true">
        <Ikona size={20} />
      </span>
      <div className="banner__content">
        <p className="banner__text">{tekst}</p>
      </div>
      {akcja && <div className="banner__action-slot">{akcja}</div>}
      {onZamknij && wariant === "info" && (
        <button type="button" className="banner__close" aria-label="Zamknij komunikat" onClick={onZamknij}>
          <IconKrzyzyk size={16} />
        </button>
      )}
    </div>
  );
}
